
export default (store) => ({
  path: 'print',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const Print = require('./containers/PrintContainer').default

      /*  Return getComponent   */
      cb(null, Print)

    /* Webpack named bundle   */
    }, 'Print')
  }
})



/** WEBPACK FOOTER **
 ** ./src/routes/Auth/routes/Discovery/routes/HealthAndHappinessTool/routes/Print/index.js
 **/